import { Divider, Surface, SurfaceProps } from '@cfa/react-core';

import { useDeviceInfo } from '@/utils/device';
import { cn } from '@/utils/tailwind';

import Constants from '@/constants';

interface StickyMenuCardProps extends SurfaceProps {
  header: string;
  /** The top position of the sticky menu card. @default '24px' */
  top?: string;
}

const StickyMenuCard: React.FC<StickyMenuCardProps> = ({
  header,
  top = '24px',
  children,
  ...rest
}) => {
  const { isDesktop } = useDeviceInfo();

  const stickyTop = isDesktop
    ? top
    : `calc(${top} + ${Constants.HEIGHT.MOBILE_TOP_NAV})`;

  const maxHeight = isDesktop
    ? `calc(100vh - ${top} - ${Constants.HEIGHT.DESKTOP_TOP_NAV} - ${Constants.HEIGHT.STICKY_MENU_MARGIN} - ${Constants.HEIGHT.STICKY_MENU_MARGIN})`
    : `calc(100vh - ${top} - ${Constants.HEIGHT.MOBILE_TOP_NAV} - ${Constants.HEIGHT.DESKTOP_TOP_NAV} - ${Constants.HEIGHT.STICKY_MENU_MARGIN} - ${Constants.HEIGHT.STICKY_MENU_MARGIN})`;

  return (
    <Surface
      elevation={1}
      radius="sm"
      {...rest}
      className={cn(
        'border-grayscale-gray2 sticky z-4 flex w-[270px] min-w-[270px] shrink flex-col justify-start gap-3 self-start overflow-y-auto border p-4',
        rest.className,
      )}
      style={{
        top: stickyTop,
        maxHeight,
        ...rest.style,
      }}
    >
      <p className="text-variant-body1 font-medium">{header}</p>
      <Divider />
      {children}
    </Surface>
  );
};

export default StickyMenuCard;
